import React, { useCallback, useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Slide from "@mui/material/Slide";
import "./Search.styles.scss";
import { InlineIcon } from "@iconify/react";
import {
  Badge,
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Grow,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  styled,
  Switch, // (NOUVEAU)
  TextField,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Slider, // (NOUVEAU)
} from "@mui/material";

import { apiGetSearchEthniesAndOrigins } from "@/features/profile/api/search.api";
import { TFilteredQuery } from "@/features/profile/types";
import { store } from "@/store";
import {
  updateFormQuery,
  updateOpenDiscussion,
  updateSearchQuery,
} from "@/store/reducers/general_param/general_param.actions";
import { selectFormQuery } from "@/store/reducers/general_param/general_param.selector";
import { Toastify } from "@/utils/toast";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";

import { MultipleSelectChip } from "@/components/MultipleSelectChip/MultipleSelectChip";
import { TMemberProfile } from "@/features/auth/types";
import {
  selectMemberProfile,
  selectMessageNotif,
} from "@/store/reducers/member/member.selector";
import useUserRestrictions from "@/hooks/useUserRestriction";
import { routePaths } from "@/config";
import UserRestrictionDisplayer from "@/components/UserRestrictionDisplayer/UserRestrictionDisplayer";
import { getMeUpdate } from "../../initialize_param/get_me_update";
import NoData from "@/components/No-data/NoData";
import useExchangeRole from "@/hooks/useExchangeRole";
import { useWebLocationSync } from "@/hooks/useWebLocationSync";
import { without } from "lodash";
import CModalInviteCorrectAdress from "@/components/Modal-invite-correct-adress/ModalInviteCorrectAdress";

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      content: '""',
    },
  },
}));

// (NOUVEAU) Marques fixes pour le Slider (50, 100, 200, 500)
const distanceMarks = [
  { value: 10, label: "10" },
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
  { value: 200, label: "200" },
  { value: 300, label: "300" },
  { value: 400, label: "400" },
  { value: 500, label: "500" },
];

interface CtSearchProps {}
const CtSearch = ({}: CtSearchProps) => {
  const {
    isUserFullAccessAutorized,
    isUserInExchange,
    isUserCloseExchangeInProgress,
  } = useUserRestrictions();

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();

  const nbre_message_notif = useSelector(selectMessageNotif);
  const { receiver } = useExchangeRole();

  const memberProfileFromStore = useSelector(
    selectMemberProfile
  ) as TMemberProfile;
  const form_query = useSelector(selectFormQuery);
  const hasSavedProfileLocation =
    memberProfileFromStore?.infos?.identity?.location?.coordinates?.length ===
    2;
  const { syncLocation, isSyncing } = useWebLocationSync();

  const [loadingList, setLoadingList] = useState(false);

  const onClose = () => {
    navigate(routePaths.profileChildren.homeAbsolute);
    setOpen(false);
  };

  type TCheckBoxList = Array<{ name: string; checked: boolean }>;

  // -----------------------------------------------
  // Checkboxes : Origines, Ethnies, Pays, Villes
  // -----------------------------------------------
  const [originList, setOriginList] = React.useState<TCheckBoxList>([]);
  const handleOriginChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const tempList = [...originList];
    if (event.target.name === "Peu importe") {
      tempList.forEach((et) => (et.checked = event.target.checked));
    } else {
      const idx = tempList.findIndex((elt) => elt.name === event.target.name);
      if (idx !== -1) tempList[idx].checked = event.target.checked;

      const idxAny = tempList.findIndex((elt) => elt.name === "Peu importe");
      if (idxAny !== -1) tempList[idxAny].checked = false;
    }
    setOriginList(tempList);
  };

  const [ethniesList, setEthiesList] = React.useState<TCheckBoxList>([]);
  const handleEthniesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const tempList = [...ethniesList];
    if (event.target.name === "Peu importe") {
      tempList.forEach((et) => (et.checked = event.target.checked));
    } else {
      const idx = tempList.findIndex((elt) => elt.name === event.target.name);
      if (idx !== -1) tempList[idx].checked = event.target.checked;

      const idxAny = tempList.findIndex((elt) => elt.name === "Peu importe");
      if (idxAny !== -1) tempList[idxAny].checked = false;
    }
    setEthiesList(tempList);
  };

  const [countriesResidenceList, setCountriesResidenceList] =
    React.useState<TCheckBoxList>([]);
  const handleCountriesChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const tempList = [...countriesResidenceList];
    if (event.target.name === "Peu importe") {
      tempList.forEach((et) => (et.checked = event.target.checked));
    } else {
      const idx = tempList.findIndex((elt) => elt.name === event.target.name);
      if (idx !== -1) tempList[idx].checked = event.target.checked;

      const idxAny = tempList.findIndex((elt) => elt.name === "Peu importe");
      if (idxAny !== -1) tempList[idxAny].checked = false;
    }
    setCountriesResidenceList(tempList);
  };

  const [cityResidenceList, setCityResidenceList] =
    React.useState<TCheckBoxList>([]);
  const handleCityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const tempList = [...cityResidenceList];
    if (event.target.name === "Peu importe") {
      tempList.forEach((et) => (et.checked = event.target.checked));
    } else {
      const idx = tempList.findIndex((elt) => elt.name === event.target.name);
      if (idx !== -1) tempList[idx].checked = event.target.checked;

      const idxAny = tempList.findIndex((elt) => elt.name === "Peu importe");
      if (idxAny !== -1) tempList[idxAny].checked = false;
    }
    setCityResidenceList(tempList);
  };

  // -----------------------------------------------
  // Listes d'options
  // -----------------------------------------------
  const tenues_vestimentaires_femmes_list = [
    "Ne porte pas encore le voile",
    "Porte le turban",
    "Porte le Hijab",
    "Porte le Jilbab",
    "Porte le Niqab",
    "L'Abaya",
  ];
  const situation_matrimoniale_femme_list = [
    "Jamais Mariée",
    "Divorcée",
    "Veuve",
  ];
  const situation_matrimoniale_homme_list = [
    "Jamais Marié",
    "Divorcé",
    "Veuf",
    "Marié",
  ];

  // -----------------------------------------------
  // Validation Yup
  // -----------------------------------------------
  const validationSchema = yup.object({
    age_minimum: yup
      .number()
      .min(18, "l'âge minimum est de 18 ans")
      .max(70, "l'âge maximum est de 70 ans")
      .test({
        name: "min_over_max",
        message: "l'âge minimum doit être inférieure à l'âge maximum",
        test: (value, ctx) => {
          if (!value) return true;
          const maxValue = ctx.parent.age_maximum;
          if (maxValue) {
            return value < maxValue;
          }
          return value < 70;
        },
      }),
    age_maximum: yup
      .number()
      .min(18, "l'âge minimum est de 18 ans")
      .max(70, "l'âge maximum est de 70 ans")
      .test({
        name: "max_over_min",
        message: "l'âge maximum doit être supérieure à l'âge minimum",
        test: (value, ctx) => {
          if (!value) return true;
          const minValue = ctx.parent.age_minimum;
          if (minValue) {
            return value > minValue;
          }
          return true;
        },
      }),
    // (NOUVEAU) On ne valide pas forcément howFarFromMe, car on a 4 valeurs fixes.
  });

  // -----------------------------------------------
  // useFormik
  // -----------------------------------------------
  const formik = useFormik({
    initialValues: {
      age_minimum: form_query.age_minimum,
      age_maximum: form_query.age_maximum,
      tenue_vestimentaire_femme: form_query.tenue_vestimentaire_femme,
      fast_filter: form_query.fast_filter,
      without_account: form_query.without_account,
      situation_matrimoniale: form_query.situation_matrimoniale,
      situation_parentale: form_query.situation_parentale,
      accepte_enfants: form_query.accepte_enfants,
      accepte_married_man: form_query.accepte_married_man,
      profils_salafi: form_query.profils_salafi,
      accepte_demenager: form_query.accepte_demenager,
      etant_hijra: form_query.etant_hijra,
      souhait_hijra: form_query.souhait_hijra,
      recherche_mon_ethnie: form_query.recherche_mon_ethnie,

      // Champs pour la recherche autour de ma ville
      enableAroundMe: form_query.enableAroundMe || false,
      howFarFromMe: form_query.howFarFromMe || 50, // Valeur par défaut
    },
    validationSchema,
    onSubmit: (values) => {
      // On complète dataToSend
      const dataToSend = {
        ...values,
        tenue_vestimentaire_femme: setArrayToGoodValue(
          values.tenue_vestimentaire_femme
        ),
        situation_matrimoniale: setArrayToGoodValue(
          values.situation_matrimoniale
        ),
        originList: cleanList(originList),
        ethniesList: cleanList(ethniesList),
        countriesResidence: cleanList(countriesResidenceList),
        cityResidence: cleanList(cityResidenceList),
      };

      // On met à jour le store
      store.dispatch(
        updateFormQuery({
          ...values,
          originList: dataToSend.originList,
          ethniesList: dataToSend.ethniesList,
          countriesResidence: dataToSend.countriesResidence,
          cityResidence: dataToSend.cityResidence,
        } as TFilteredQuery)
      );

      // Construire la query
      const queryToSend = buildQueryString(dataToSend);
      store.dispatch(updateSearchQuery(queryToSend));

      // Redirection
      navigate(routePaths.profileChildren.homeAbsolute);
    },
    onReset: () => {
      resetFilter();
      navigate(routePaths.profileChildren.homeAbsolute);
    },
  });

  // -----------------------------------------------
  // resetFilter
  // -----------------------------------------------
  const resetFilter = useCallback(() => {
    // On va vider tous les champs, y compris enableAroundMe
    const initValues = {
      age_minimum: "",
      age_maximum: "",
      tenue_vestimentaire_femme: [],
      fast_filter: "",
      without_account: "",
      situation_matrimoniale: [],
      situation_parentale: "",
      accepte_enfants: "",
      accepte_married_man: "",
      profils_salafi: "",
      accepte_demenager: "",
      etant_hijra: "",
      souhait_hijra: "",
      recherche_mon_ethnie: "",
      originList: [],
      ethniesList: [],
      countriesResidence: [],
      cityResidence: [],
      howFarFromMe: 50,
      enableAroundMe: false,
    };

    // On force Formik à prendre les nouvelles valeurs
    formik.setFieldValue("enableAroundMe", false);
    formik.setFieldValue("howFarFromMe", 50);

    // Décocher toutes les checkboxes
    setOriginList(originList.map((et) => ({ ...et, checked: false })));
    setEthiesList(ethniesList.map((et) => ({ ...et, checked: false })));
    setCountriesResidenceList(
      countriesResidenceList.map((et) => ({ ...et, checked: false }))
    );
    setCityResidenceList(
      cityResidenceList.map((et) => ({ ...et, checked: false }))
    );

    // Mise à jour du store
    store.dispatch(updateFormQuery({ ...initValues } as TFilteredQuery));
    store.dispatch(updateSearchQuery(""));

    Toastify(
      `Le filtre de recherche a bien été réinitialisé `,
      "success",
      5000
    );
  }, [originList, ethniesList, countriesResidenceList, cityResidenceList]);

  // -----------------------------------------------
  // buildQueryString
  // -----------------------------------------------
  const buildQueryString = (values: any): string => {
    let result = "";

    if (values.fast_filter === "consulted") {
      result += "&isVisited=true";
    } else if (values.fast_filter === "not_consulted") {
      result += "&isVisited=false";
    } else if (values.fast_filter === "my_spectators") {
      result += "&hasVisited=true";
    }

    if (values.without_account !== "") {
      // "true" => on veut des profils SANS abo => &onlyWithSubscription=false
      const onlyWithSub = values.without_account === "true" ? "false" : "true";
      result += `&onlyWithSubscription=${onlyWithSub}`;
    }

    if (values.age_minimum !== "") result += `&minAge=${values.age_minimum}`;
    if (values.age_maximum !== "") result += `&maxAge=${values.age_maximum}`;

    if (values.tenue_vestimentaire_femme.length > 0) {
      result +=
        "&femaleDressCode[]=" +
        values.tenue_vestimentaire_femme.join("&femaleDressCode[]=");
    }
    if (values.situation_matrimoniale.length > 0) {
      result +=
        "&maritalStatus[]=" +
        values.situation_matrimoniale.join("&maritalStatus[]=");
    }
    if (values.situation_parentale !== "") {
      result += `&haveChildren=${values.situation_parentale}`;
    }
    if (values.accepte_enfants !== "") {
      result += `&acceptChildren=${values.accepte_enfants}`;
    }
    if (values.accepte_married_man !== "") {
      result += `&acceptMarriedMan=${values.accepte_married_man}`;
    }
    if (values.profils_salafi !== "") {
      result += `&isSalafi=${values.profils_salafi}`;
    }
    if (values.accepte_demenager !== "") {
      result += `&agreeToMove=${values.accepte_demenager}`;
    }
    if (values.etant_hijra !== "") {
      result += `&isInHijra=${values.etant_hijra}`;
    }
    if (values.souhait_hijra !== "") {
      result += `&likeToMakeHijra=${values.souhait_hijra}`;
    }
    if (values.recherche_mon_ethnie !== "") {
      result += `&wantMyEthnicity=${values.recherche_mon_ethnie}`;
    }

    if (values.ethniesList.length > 0) {
      result +=
        "&wantedEthnicities[]=" +
        customArrayToString(values.ethniesList, true, "&wantedEthnicities[]=");
    }
    if (values.originList.length > 0) {
      result +=
        "&wantedCountries[]=" +
        customArrayToString(values.originList, false, "&wantedCountries[]=");
    }

    // Si on n’est PAS en mode autour de ma ville, on applique la logique pays/ville
    if (!values.enableAroundMe) {
      if (values.countriesResidence.length > 0) {
        result +=
          "&wantedCountriesResidence[]=" +
          customArrayToString(
            values.countriesResidence,
            false,
            "&wantedCountriesResidence[]="
          );
      }
      if (values.cityResidence.length > 0) {
        result +=
          "&wantedCityResidence[]=" +
          customArrayToString(
            values.cityResidence,
            false,
            "&wantedCityResidence[]="
          );
      }
    } else {
      result += `&distance=${values.howFarFromMe}`;
    }

    return result;
  };

  // -----------------------------------------------
  // Helpers
  // -----------------------------------------------
  const cleanList = (data: TCheckBoxList): TCheckBoxList => {
    // Supprime les "Peu importe" + garde seulement checked=true
    return data.filter((item) => item.checked && item.name !== "Peu importe");
  };
  const setArrayToGoodValue = (arr: string[]): string[] => {
    const result: string[] = [];
    arr.forEach((elt) => {
      // Tenue vestimentaire
      if (elt === "Ne porte pas encore le voile")
        result.push("notWearHeadscarf");
      if (elt === "Porte le turban") result.push("wearTurban");
      if (elt === "Porte le Hijab") result.push("wearHijab");
      if (elt === "Porte le Jilbab") result.push("wearJilbab");
      if (elt === "Porte le Niqab") result.push("wearNiqab");
      if (elt === "L'Abaya") result.push("wearAbaya");

      // Situation maritale
      if (elt === "Jamais Mariée" || elt === "Jamais Marié")
        result.push("NEVER_MARRIED");
      if (elt === "Divorcée" || elt === "Divorcé") result.push("DIVORCED");
      if (elt === "Veuve" || elt === "Veuf") result.push("WIDOW");
      if (elt === "Marié") result.push("MARRIED");
    });
    return result;
  };
  const customArrayToString = (
    arr: any[],
    isId: boolean = false,
    joinString: string = ","
  ): string => {
    const result: string[] = [];
    arr.forEach((elt) => {
      result.push(isId ? elt.id : elt.name);
    });
    return result.join(joinString);
  };

  // -----------------------------------------------
  // Chargement des données
  // -----------------------------------------------
  useEffect(() => {
    setLoadingList(true);

    if (open) {
      apiGetSearchEthniesAndOrigins()
        .then((response: any) => {
          setLoadingList(false);

          // Origines
          const tempList = response.data.origins.map((data: any) => ({
            name: data,
            checked:
              form_query.originList.some((x) => x.name === data) || false,
          }));
          setOriginList([{ name: "Peu importe", checked: false }, ...tempList]);

          // Ethnies
          const tempList2 = response.data.ethnicities.map((data: any) => ({
            id: data._id,
            name: data.name,
            checked:
              form_query.ethniesList.some((x) => x.name === data.name) || false,
          }));
          setEthiesList([
            { name: "Peu importe", checked: false },
            ...tempList2,
          ]);

          // Pays
          if (!form_query.countriesResidence) {
            store.dispatch(
              updateFormQuery({ ...form_query, countriesResidence: [] })
            );
          }
          const tempList3 = response.data.countriesOfResidence.map(
            (data: any) => ({
              name: data,
              checked:
                form_query?.countriesResidence?.some(
                  (x: any) => x.name === data
                ) || false,
            })
          );
          setCountriesResidenceList([
            { name: "Peu importe", checked: false },
            ...tempList3,
          ]);

          // Villes
          if (!form_query.cityResidence) {
            store.dispatch(
              updateFormQuery({ ...form_query, cityResidence: [] })
            );
          }
          const tempList4 =
            response.data?.cityOfResidence?.map((data: any) => ({
              name: data,
              checked:
                form_query?.cityResidence?.some((x: any) => x.name === data) ||
                false,
            })) || [];
          setCityResidenceList([
            { name: "Peu importe", checked: false },
            ...tempList4,
          ]);
        })
        .catch((error) => {
          setLoadingList(false);
          // ...
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    getMeUpdate();
  }, []);

  // -----------------------------------------------
  // Recherche textuelle
  // -----------------------------------------------
  const [searchedOriginText, setSearchedOriginText] = useState("");
  const handleSearchOriginTextChange = useCallback((e: any) => {
    setSearchedOriginText(e.target.value);
  }, []);
  const clearOriginTextSearch = useCallback(() => {
    setSearchedOriginText("");
  }, []);

  const [searchedEthnieText, setSearchedEthnieText] = useState("");
  const handleSearchEthnieTextChange = useCallback((e: any) => {
    setSearchedEthnieText(e.target.value);
  }, []);
  const clearEthnieTextSearch = useCallback(() => {
    setSearchedEthnieText("");
  }, []);

  const [searchedCountryText, setSearchedCountryText] = useState("");
  const handleSearchCountryTextChange = useCallback((e: any) => {
    setSearchedCountryText(e.target.value);
  }, []);
  const clearCountryTextSearch = useCallback(() => {
    setSearchedCountryText("");
  }, []);

  const [searchedCityText, setSearchedCityText] = useState("");
  const handleSearchCityTextChange = useCallback((e: any) => {
    setSearchedCityText(e.target.value);
  }, []);
  const clearCityTextSearch = useCallback(() => {
    setSearchedCityText("");
  }, []);

  const { hasUserUnproperedCityCountryMatch } = useUserRestrictions();

  // -----------------------------------------------
  // Rendu
  // -----------------------------------------------
  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={onClose}
        closeAfterTransition
      >
        {isUserFullAccessAutorized ? (
          <Slide direction="left" in={open} mountOnEnter unmountOnExit>
            <div className="c-modal-research">
              <div className="c-modal-research__title-part">
                <IconButton
                  className="back-icon"
                  size="medium"
                  color="secondary"
                  onClick={onClose}
                >
                  <InlineIcon icon="tabler:chevron-left" />
                </IconButton>
                <span className="title">Critères de recherches</span>
                <IconButton
                  className="close-icon"
                  size="medium"
                  color="secondary"
                  onClick={onClose}
                >
                  <InlineIcon icon="iconamoon:close-bold" />
                </IconButton>
              </div>

              {/* Si l'utilisateur est en échange ou closeExchange => pas accès */}
              {isUserInExchange || isUserCloseExchangeInProgress ? (
                <div className="ct-home" style={{ padding: "20px" }}>
                  <NoData />
                  {isUserInExchange && (
                    <p
                      style={{
                        width: "100%",
                        textAlign: "center",
                        fontSize: "1.2rem",
                      }}
                    >
                      Vous êtes actuellement en <b>échange</b>
                      {receiver?.username && (
                        <>
                          {" "}
                          avec{" "}
                          <b style={{ color: "var(--ui-primary)" }}>
                            {receiver?.username}
                          </b>
                        </>
                      )}
                      . <br />
                      Vous ne pouvez pas avoir accès aux autres profils <br />
                      <br />
                      <Button
                        variant="contained"
                        onClick={() => {
                          store.dispatch(updateOpenDiscussion(true));
                          navigate(
                            routePaths.profileChildren.exchangeAbsolute,
                            {
                              replace: true,
                            }
                          );
                        }}
                        startIcon={
                          <InlineIcon icon="bx:message-rounded-detail" />
                        }
                        color="primary"
                        style={{
                          width: "fit-content",
                          fontSize: "1rem",
                          padding: "10px 20px",
                        }}
                      >
                        <>Accéder à l'échange</>
                        {nbre_message_notif > 0 && (
                          <>
                                
                            <StyledBadge
                              overlap="circular"
                              variant="standard"
                              color="warning"
                              badgeContent={nbre_message_notif}
                            />
                          </>
                        )}
                      </Button>
                    </p>
                  )}
                  {isUserCloseExchangeInProgress && (
                    <p
                      style={{
                        width: "100%",
                        textAlign: "center",
                        fontSize: "1.2rem",
                      }}
                    >
                      Votre clôture d'échange est actuellement en{" "}
                      <b>examination</b> auprès de nos modérateurs. <br />
                      Vous ne pouvez pas avoir accès aux autres profils
                    </p>
                  )}
                </div>
              ) : (
                <>
                  {/* Boutons d'action */}
                  <div className="c-modal-research__actions-part">
                    <Chip
                      className="action-chip erase"
                      color="primary"
                      variant="outlined"
                      size="medium"
                      label="Réinitialiser"
                      icon={<InlineIcon icon={"carbon:reset"} />}
                      onClick={formik.handleReset}
                    />

                    <Chip
                      className="action-chip"
                      color="primary"
                      variant="filled"
                      size="medium"
                      label="Effectuer le filtre"
                      icon={
                        <InlineIcon
                          icon={
                            loading
                              ? "eos-icons:three-dots-loading"
                              : "mingcute:check-fill"
                          }
                        />
                      }
                      onClick={() => {
                        if (!loading) formik.handleSubmit();
                      }}
                    />
                  </div>

                  {loading ? (
                    <img
                      src={require("@/assets/images/gif/loadmore.gif")}
                      height="70"
                      width="70"
                      className="load-more"
                      alt="load-more"
                    />
                  ) : (
                    <form
                      className="c-modal-research__body-part"
                      onSubmit={formik.handleSubmit}
                      onReset={formik.handleReset}
                    >
                      <Box>
                        <Grid container rowSpacing={3} columnSpacing={2}>
                          {/* Filtre rapide */}

                          {/* (NOUVEAU) Switch - autour de ma ville ? */}
                          <Grid item xs={12}>
                            <FormControlLabel
                              className="ctrl-label"
                              label="Chercher les profils autour de ma ville ?"
                              control={
                                <Switch
                                  checked={formik.values.enableAroundMe}
                                  onChange={async (e) => {
                                    const checked = e.target.checked;

                                    if (!checked) {
                                      formik.setFieldValue(
                                        "enableAroundMe",
                                        false
                                      );
                                      return;
                                    }

                                    const result = await syncLocation();

                                    if (result.success) {
                                      formik.setFieldValue(
                                        "enableAroundMe",
                                        true
                                      );
                                      return;
                                    }

                                    if (hasSavedProfileLocation) {
                                      formik.setFieldValue(
                                        "enableAroundMe",
                                        true
                                      );
                                      
                                      let message = "Geolocalisation actuelle indisponible. Utilisation de votre derniere position enregistree.";
                                      if (result.errorType === "PERMISSION_DENIED") {
                                        message = "Permission refusee. Utilisation de votre derniere position. Pour activer : Reglages > Safari > Localisation > Ce site web > Autoriser.";
                                      } else if (result.errorType === "TIMEOUT") {
                                        message = "Delai expire. Utilisation de votre derniere position enregistree.";
                                      }
                                      
                                      Toastify(message, "info", 5000);
                                      return;
                                    }

                                    formik.setFieldValue(
                                      "enableAroundMe",
                                      false
                                    );
                                    
                                    let errorMessage = "Geolocalisation non disponible.";
                                    if (result.errorType === "PERMISSION_DENIED") {
                                      errorMessage = "Permission refusee. Activez la localisation : Reglages > Safari > Localisation > Ce site web > Autoriser.";
                                    } else if (result.errorType === "NOT_SUPPORTED") {
                                      errorMessage = "Votre navigateur ne supporte pas la geolocalisation.";
                                    } else if (result.errorType === "TIMEOUT") {
                                      errorMessage = "Impossible d'obtenir votre position. Verifiez votre connexion et reessayez.";
                                    } else if (result.errorType === "NETWORK_ERROR") {
                                      errorMessage = "Erreur reseau. Verifiez votre connexion Internet.";
                                    }
                                    
                                    Toastify(errorMessage, "error", 5000);
                                  }}
                                  disabled={isSyncing}
                                />
                              }
                            />
                          </Grid>

                          {/* (NOUVEAU) Slider - distance */}
                          {formik.values.enableAroundMe && (
                            <Grid item xs={12}>
                              <p className="label">Rayon de recherche (Km)</p>
                              <Slider
                                value={formik.values.howFarFromMe}
                                onChange={(event, newValue) => {
                                  formik.setFieldValue(
                                    "howFarFromMe",
                                    newValue
                                  );
                                }}
                                step={null}
                                marks={distanceMarks}
                                min={50}
                                max={500}
                                sx={{ maxWidth: "90%", marginX: "auto" }}
                              />
                            </Grid>
                          )}

                          <Grid item xs={12} sm={12} lg={12}>
                            <p className="label">Filtre rapide</p>
                            <FormControl
                              fullWidth
                              color="primary"
                              className="input-radio"
                            >
                              <RadioGroup
                                row
                                name="fast_filter"
                                value={formik.values.fast_filter}
                                onChange={formik.handleChange}
                              >
                                <FormControlLabel
                                  value="consulted"
                                  control={<Radio />}
                                  label="Profiles consultés"
                                />
                                <FormControlLabel
                                  value="not_consulted"
                                  control={<Radio />}
                                  label="Profiles non consultés"
                                />
                                <FormControlLabel
                                  value="my_spectators"
                                  control={<Radio />}
                                  label="Mes spectateurs"
                                />
                              </RadioGroup>
                            </FormControl>
                          </Grid>

                          {/* Profils sans abonnement */}
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <p className="label">
                              Afficher les profils sans abonnements ?
                            </p>
                            <FormControl
                              fullWidth
                              color="primary"
                              className="input-radio"
                            >
                              <RadioGroup
                                row
                                name="without_account"
                                value={formik.values.without_account}
                                onChange={formik.handleChange}
                              >
                                <FormControlLabel
                                  value="true"
                                  control={<Radio />}
                                  label="Oui"
                                />
                                <FormControlLabel
                                  value="false"
                                  control={<Radio />}
                                  label="Non"
                                />
                                <FormControlLabel
                                  value=""
                                  control={<Radio />}
                                  label="Peu importe"
                                />
                              </RadioGroup>
                            </FormControl>
                          </Grid>

                          {/* Age min / max */}
                          <Grid item xs={12} sm={12} lg={12}>
                            <p className="label">Âge minimum (18)</p>
                            <TextField
                              variant="outlined"
                              name="age_minimum"
                              onChange={formik.handleChange}
                              value={formik.values.age_minimum}
                              error={
                                formik.touched.age_minimum &&
                                Boolean(formik.errors.age_minimum)
                              }
                              helperText={
                                formik.touched.age_minimum &&
                                formik.errors.age_minimum
                              }
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <span className="suffix">ans</span>
                                  </InputAdornment>
                                ),
                              }}
                              type="number"
                            />
                          </Grid>

                          <Grid item xs={12} sm={12} lg={12}>
                            <p className="label">Âge maximum (70)</p>
                            <TextField
                              variant="outlined"
                              name="age_maximum"
                              onChange={formik.handleChange}
                              value={formik.values.age_maximum}
                              error={
                                formik.touched.age_maximum &&
                                Boolean(formik.errors.age_maximum)
                              }
                              helperText={
                                formik.touched.age_maximum &&
                                formik.errors.age_maximum
                              }
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <span className="suffix">ans</span>
                                  </InputAdornment>
                                ),
                              }}
                              type="number"
                            />
                          </Grid>

                          {/* Tenue vestimentaire (si user = MALE) */}
                          {memberProfileFromStore?.infos?.identity?.gender ===
                            "MALE" && (
                            <Grid item xs={12} sm={12} lg={12}>
                              <p className="label">Tenue vestimentaire</p>
                              <MultipleSelectChip
                                name="tenue_vestimentaire_femme"
                                selectOptions={
                                  tenues_vestimentaires_femmes_list
                                }
                                value={formik.values.tenue_vestimentaire_femme}
                                onChange={formik.handleChange}
                                labelId="id-select-tenue-femme"
                                label=""
                                errorText={
                                  formik.errors.tenue_vestimentaire_femme
                                }
                                error={
                                  formik.touched.tenue_vestimentaire_femme &&
                                  Boolean(
                                    formik.errors.tenue_vestimentaire_femme
                                  )
                                }
                              />
                            </Grid>
                          )}

                          {/* Situation matrimoniale */}
                          <Grid item xs={12} sm={12} lg={12}>
                            {memberProfileFromStore?.infos?.identity?.gender ===
                              "FEMALE" && (
                              <>
                                <p className="label">Situation matrimoniale</p>
                                <MultipleSelectChip
                                  name="situation_matrimoniale"
                                  selectOptions={
                                    situation_matrimoniale_homme_list
                                  }
                                  value={formik.values.situation_matrimoniale}
                                  onChange={formik.handleChange}
                                  labelId="id-situation_matrimoniale"
                                  label=""
                                  errorText={
                                    formik.errors.situation_matrimoniale
                                  }
                                  error={
                                    formik.touched.situation_matrimoniale &&
                                    Boolean(
                                      formik.errors.situation_matrimoniale
                                    )
                                  }
                                />
                              </>
                            )}
                            {memberProfileFromStore?.infos?.identity?.gender ===
                              "MALE" && (
                              <>
                                <p className="label">Situation matrimoniale</p>
                                <MultipleSelectChip
                                  name="situation_matrimoniale"
                                  selectOptions={
                                    situation_matrimoniale_femme_list
                                  }
                                  value={formik.values.situation_matrimoniale}
                                  onChange={formik.handleChange}
                                  labelId="id-situation_matrimoniale"
                                  label=""
                                  errorText={
                                    formik.errors.situation_matrimoniale
                                  }
                                  error={
                                    formik.touched.situation_matrimoniale &&
                                    Boolean(
                                      formik.errors.situation_matrimoniale
                                    )
                                  }
                                />
                              </>
                            )}
                          </Grid>

                          {/* Situation parentale */}
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <p className="label">Situation parentale</p>
                            <FormControl
                              fullWidth
                              color="primary"
                              className="input-radio"
                            >
                              <RadioGroup
                                row
                                name="situation_parentale"
                                value={formik.values.situation_parentale}
                                onChange={formik.handleChange}
                              >
                                <FormControlLabel
                                  value="true"
                                  control={<Radio />}
                                  label="Avec enfants"
                                />
                                <FormControlLabel
                                  value="false"
                                  control={<Radio />}
                                  label="Sans enfants"
                                />
                                <FormControlLabel
                                  value=""
                                  control={<Radio />}
                                  label="Peu importe"
                                />
                              </RadioGroup>
                            </FormControl>
                          </Grid>

                          {/* Qui accepte hommes mariés ? (si user = MALE) */}
                          {memberProfileFromStore?.infos?.identity?.gender ===
                            "MALE" && (
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                              <p className="label">
                                Qui accepte les hommes mariés ?
                              </p>
                              <FormControl
                                fullWidth
                                color="primary"
                                className="input-radio"
                              >
                                <RadioGroup
                                  row
                                  name="accepte_married_man"
                                  value={formik.values.accepte_married_man}
                                  onChange={formik.handleChange}
                                >
                                  <FormControlLabel
                                    value="true"
                                    control={<Radio />}
                                    label="Oui"
                                  />
                                  <FormControlLabel
                                    value="false"
                                    control={<Radio />}
                                    label="Non"
                                  />
                                  <FormControlLabel
                                    value=""
                                    control={<Radio />}
                                    label="Peu importe"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Grid>
                          )}

                          {/* Qui accepte enfants ? */}
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <p className="label">Qui accepte les enfants ?</p>
                            <FormControl
                              fullWidth
                              color="primary"
                              className="input-radio"
                            >
                              <RadioGroup
                                row
                                name="accepte_enfants"
                                value={formik.values.accepte_enfants}
                                onChange={formik.handleChange}
                              >
                                <FormControlLabel
                                  value="true"
                                  control={<Radio />}
                                  label="Oui"
                                />
                                <FormControlLabel
                                  value="false"
                                  control={<Radio />}
                                  label="Non"
                                />
                                <FormControlLabel
                                  value=""
                                  control={<Radio />}
                                  label="Peu importe"
                                />
                              </RadioGroup>
                            </FormControl>
                          </Grid>

                          {/* Profils salafis ? */}
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <p className="label">
                              N'afficher que les profils salafis ?
                            </p>
                            <FormControl
                              fullWidth
                              color="primary"
                              className="input-radio"
                            >
                              <RadioGroup
                                row
                                name="profils_salafi"
                                value={formik.values.profils_salafi}
                                onChange={formik.handleChange}
                              >
                                <FormControlLabel
                                  value="true"
                                  control={<Radio />}
                                  label="Oui"
                                />
                                <FormControlLabel
                                  value="false"
                                  control={<Radio />}
                                  label="Non"
                                />
                                <FormControlLabel
                                  value=""
                                  control={<Radio />}
                                  label="Peu importe"
                                />
                              </RadioGroup>
                            </FormControl>
                          </Grid>

                          {/* Qui accepte de déménager */}
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <p className="label">Qui accepte de déménager ?</p>
                            <FormControl
                              fullWidth
                              color="primary"
                              className="input-radio"
                            >
                              <RadioGroup
                                row
                                name="accepte_demenager"
                                value={formik.values.accepte_demenager}
                                onChange={formik.handleChange}
                              >
                                <FormControlLabel
                                  value="true"
                                  control={<Radio />}
                                  label="Oui"
                                />
                                <FormControlLabel
                                  value="false"
                                  control={<Radio />}
                                  label="Non"
                                />
                                <FormControlLabel
                                  value=""
                                  control={<Radio />}
                                  label="Peu importe"
                                />
                              </RadioGroup>
                            </FormControl>
                          </Grid>

                          {/* Hijra */}
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <p className="label">Étant en hijra ?</p>
                            <FormControl
                              fullWidth
                              color="primary"
                              className="input-radio"
                            >
                              <RadioGroup
                                row
                                name="etant_hijra"
                                value={formik.values.etant_hijra}
                                onChange={formik.handleChange}
                              >
                                <FormControlLabel
                                  value="true"
                                  control={<Radio />}
                                  label="Oui"
                                />
                                <FormControlLabel
                                  value="false"
                                  control={<Radio />}
                                  label="Non"
                                />
                                <FormControlLabel
                                  value=""
                                  control={<Radio />}
                                  label="Peu importe"
                                />
                              </RadioGroup>
                            </FormControl>
                          </Grid>

                          {/* Souhait Hijra */}
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <p className="label">Souhaitant faire la hijra ?</p>
                            <FormControl
                              fullWidth
                              color="primary"
                              className="input-radio"
                            >
                              <RadioGroup
                                row
                                name="souhait_hijra"
                                value={formik.values.souhait_hijra}
                                onChange={formik.handleChange}
                              >
                                <FormControlLabel
                                  value="true"
                                  control={<Radio />}
                                  label="Oui"
                                />
                                <FormControlLabel
                                  value="false"
                                  control={<Radio />}
                                  label="Non"
                                />
                                <FormControlLabel
                                  value=""
                                  control={<Radio />}
                                  label="Peu importe"
                                />
                              </RadioGroup>
                            </FormControl>
                          </Grid>

                          {/* Recherche mon ethnie */}
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <p className="label">
                              Afficher les profils qui recherchent mon ethnie
                            </p>
                            <FormControl
                              fullWidth
                              color="primary"
                              className="input-radio"
                            >
                              <RadioGroup
                                row
                                name="recherche_mon_ethnie"
                                value={formik.values.recherche_mon_ethnie}
                                onChange={formik.handleChange}
                              >
                                <FormControlLabel
                                  value="true"
                                  control={<Radio />}
                                  label="Oui"
                                />
                                <FormControlLabel
                                  value="false"
                                  control={<Radio />}
                                  label="Non"
                                />
                                <FormControlLabel
                                  value=""
                                  control={<Radio />}
                                  label="Peu importe"
                                />
                              </RadioGroup>
                            </FormControl>
                          </Grid>

                          {/* Origines */}
                          <Grid item xs={12} sm={12} lg={12}>
                            <p className="label">Origines</p>
                            <FormControl className="yel-checkbox-list">
                              <TextField
                                placeholder="Recherche ..."
                                variant="outlined"
                                className="searchInput"
                                type="text"
                                value={searchedOriginText}
                                onChange={handleSearchOriginTextChange}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Grow in={searchedOriginText === ""}>
                                        <div>
                                          <InlineIcon icon="bi:search" />
                                        </div>
                                      </Grow>
                                    </InputAdornment>
                                  ),
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Grow in={searchedOriginText !== ""}>
                                        <div>
                                          <IconButton
                                            className="sm-btn"
                                            size="medium"
                                            onClick={clearOriginTextSearch}
                                          >
                                            <InlineIcon
                                              icon="mdi:erase"
                                              color="var(--ui-medium)"
                                            />
                                          </IconButton>
                                        </div>
                                      </Grow>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                              <FormGroup className="yel-checkbox-option-container">
                                {loadingList ? (
                                  <img
                                    src={require("@/assets/images/gif/loadmore.gif")}
                                    height="70"
                                    width="70"
                                    alt="load-more"
                                  />
                                ) : (
                                  originList
                                    .filter((elt) =>
                                      elt.name
                                        .toLowerCase()
                                        .normalize("NFD")
                                        .replace(/[\u0300-\u036f]/g, "")
                                        .includes(
                                          searchedOriginText
                                            .toLowerCase()
                                            .normalize("NFD")
                                            .replace(/[\u0300-\u036f]/g, "")
                                        )
                                    )
                                    .map((origin, index) => (
                                      <FormControlLabel
                                        key={index}
                                        color="primary"
                                        control={
                                          <Checkbox
                                            color="primary"
                                            checked={origin.checked}
                                            onChange={handleOriginChange}
                                            name={origin.name}
                                          />
                                        }
                                        label={origin.name}
                                      />
                                    ))
                                )}
                              </FormGroup>
                            </FormControl>
                          </Grid>

                          {/* Ethnies */}
                          <Grid item xs={12} sm={12} lg={12}>
                            <p className="label">Ethnies</p>
                            <FormControl className="yel-checkbox-list">
                              <TextField
                                placeholder="Recherche ..."
                                variant="outlined"
                                className="searchInput"
                                type="text"
                                value={searchedEthnieText}
                                onChange={handleSearchEthnieTextChange}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Grow in={searchedEthnieText === ""}>
                                        <div>
                                          <InlineIcon icon="bi:search" />
                                        </div>
                                      </Grow>
                                    </InputAdornment>
                                  ),
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Grow in={searchedEthnieText !== ""}>
                                        <div>
                                          <IconButton
                                            className="sm-btn"
                                            size="medium"
                                            onClick={clearEthnieTextSearch}
                                          >
                                            <InlineIcon
                                              icon="mdi:erase"
                                              color="var(--ui-medium)"
                                            />
                                          </IconButton>
                                        </div>
                                      </Grow>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                              <FormGroup className="yel-checkbox-option-container">
                                {loadingList ? (
                                  <img
                                    src={require("@/assets/images/gif/loadmore.gif")}
                                    height="70"
                                    width="70"
                                    alt="load-more"
                                  />
                                ) : (
                                  ethniesList
                                    .filter((elt) =>
                                      elt.name
                                        .toLowerCase()
                                        .normalize("NFD")
                                        .replace(/[\u0300-\u036f]/g, "")
                                        .includes(
                                          searchedEthnieText
                                            .toLowerCase()
                                            .normalize("NFD")
                                            .replace(/[\u0300-\u036f]/g, "")
                                        )
                                    )
                                    .map((ethny, index) => (
                                      <FormControlLabel
                                        key={index}
                                        control={
                                          <Checkbox
                                            color="primary"
                                            checked={ethny.checked}
                                            onChange={handleEthniesChange}
                                            name={ethny.name}
                                          />
                                        }
                                        label={ethny.name}
                                      />
                                    ))
                                )}
                              </FormGroup>
                            </FormControl>
                          </Grid>

                          {/* Pays de résidence (désactivé si aroundMe) */}
                          <Grid item xs={12} sm={12} lg={12}>
                            <p className="label">Pays de résidence</p>
                            <FormControl className="yel-checkbox-list">
                              {formik.values.enableAroundMe && (
                                <p
                                  style={{
                                    color: "var(--ui-error)",
                                    fontStyle: "italic",
                                    marginBottom: "10px",
                                  }}
                                >
                                  Impossible de filtrer par pays lorsque la
                                  recherche “autour de ma ville” est activée.
                                </p>
                              )}

                              <TextField
                                placeholder="Recherche ..."
                                variant="outlined"
                                className="searchInput"
                                disabled={formik.values.enableAroundMe}
                                type="text"
                                value={searchedCountryText}
                                onChange={handleSearchCountryTextChange}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Grow in={searchedCountryText === ""}>
                                        <div>
                                          <InlineIcon icon="bi:search" />
                                        </div>
                                      </Grow>
                                    </InputAdornment>
                                  ),
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Grow in={searchedCountryText !== ""}>
                                        <div>
                                          <IconButton
                                            className="sm-btn"
                                            size="medium"
                                            onClick={clearCountryTextSearch}
                                          >
                                            <InlineIcon
                                              icon="mdi:erase"
                                              color="var(--ui-medium)"
                                            />
                                          </IconButton>
                                        </div>
                                      </Grow>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                              <FormGroup className="yel-checkbox-option-container">
                                {loadingList ? (
                                  <img
                                    src={require("@/assets/images/gif/loadmore.gif")}
                                    height="70"
                                    width="70"
                                    alt="load-more"
                                  />
                                ) : (
                                  countriesResidenceList
                                    .filter((elt) =>
                                      elt.name
                                        .toLowerCase()
                                        .normalize("NFD")
                                        .replace(/[\u0300-\u036f]/g, "")
                                        .includes(
                                          searchedCountryText
                                            .toLowerCase()
                                            .normalize("NFD")
                                            .replace(/[\u0300-\u036f]/g, "")
                                        )
                                    )
                                    .map((country, index) => (
                                      <FormControlLabel
                                        key={index}
                                        control={
                                          <Checkbox
                                            color="primary"
                                            checked={country.checked}
                                            onChange={handleCountriesChange}
                                            name={country.name}
                                            disabled={
                                              formik.values.enableAroundMe
                                            } // (NOUVEAU)
                                          />
                                        }
                                        label={country.name}
                                      />
                                    ))
                                )}
                              </FormGroup>
                            </FormControl>
                          </Grid>

                          {/* Ville de résidence (désactivé si aroundMe) */}
                          {false && (
                            <Grid item xs={12} sm={12} lg={12}>
                              <p className="label">Ville de résidence</p>
                              <FormControl className="yel-checkbox-list">
                                <TextField
                                  placeholder="Recherche ..."
                                  variant="outlined"
                                  className="searchInput"
                                  type="text"
                                  value={searchedCityText}
                                  onChange={handleSearchCityTextChange}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <Grow in={searchedCityText === ""}>
                                          <div>
                                            <InlineIcon icon="bi:search" />
                                          </div>
                                        </Grow>
                                      </InputAdornment>
                                    ),
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Grow in={searchedCityText !== ""}>
                                          <div>
                                            <IconButton
                                              className="sm-btn"
                                              size="medium"
                                              onClick={clearCityTextSearch}
                                            >
                                              <InlineIcon
                                                icon="mdi:erase"
                                                color="var(--ui-medium)"
                                              />
                                            </IconButton>
                                          </div>
                                        </Grow>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                                <FormGroup className="yel-checkbox-option-container">
                                  {loadingList ? (
                                    <img
                                      src={require("@/assets/images/gif/loadmore.gif")}
                                      height="70"
                                      width="70"
                                      alt="load-more"
                                    />
                                  ) : (
                                    cityResidenceList
                                      .filter((elt) =>
                                        elt.name
                                          .toLowerCase()
                                          .normalize("NFD")
                                          .replace(/[\u0300-\u036f]/g, "")
                                          .includes(
                                            searchedCityText
                                              .toLowerCase()
                                              .normalize("NFD")
                                              .replace(/[\u0300-\u036f]/g, "")
                                          )
                                      )
                                      .map((city, index) => (
                                        <FormControlLabel
                                          key={index}
                                          control={
                                            <Checkbox
                                              color="primary"
                                              checked={city.checked}
                                              onChange={handleCityChange}
                                              name={city.name}
                                              disabled={
                                                formik.values.enableAroundMe
                                              } // (NOUVEAU)
                                            />
                                          }
                                          label={city.name}
                                        />
                                      ))
                                  )}
                                </FormGroup>
                              </FormControl>
                            </Grid>
                          )}
                        </Grid>
                      </Box>
                    </form>
                  )}
                </>
              )}
            </div>
          </Slide>
        ) : (
          <Slide direction="left" in={open} mountOnEnter unmountOnExit>
            <div className="c-modal-research">
              <div className="c-modal-research__title-part">
                <IconButton
                  className="back-icon"
                  size="medium"
                  color="secondary"
                  onClick={onClose}
                >
                  <InlineIcon icon="tabler:chevron-left" />
                </IconButton>
                <span className="title">Critères de recherches</span>
                <IconButton
                  className="close-icon"
                  size="medium"
                  color="secondary"
                  onClick={onClose}
                >
                  <InlineIcon icon="iconamoon:close-bold" />
                </IconButton>
              </div>
              <div className="ct-home">
                <UserRestrictionDisplayer />
              </div>
            </div>
          </Slide>
        )}
      </Modal>
      {/* <CModalInviteCorrectAdress open={hasUserUnproperedCityCountryMatch} /> */}
    </>
  );
};

export default CtSearch;
